/* eslint-disable import/prefer-default-export */
import { isCompleted } from '@models/Course';

export const processTestSeriesData = (test) => ({
  ...test,
  isCompleted: test.isCompleted || isCompleted(test.endsAt),
  nextTrack: {
    ...(test.nextTrack || test.nextSession),
    ...(test.nextTrack?.properties || test.nextSession?.properties || {})
  }
});
